import React from 'react';
import { Footer, Layout, SpaceWrapper } from 'ui-toolkit';
import { PageHeader } from '../components/PageHeader';
import { OrdersActiveContainer } from './OrdersActiveContainer';
import { clientUrls } from '../../ui-toolkit/rest/ClientUrlFactory';
import { useHistory } from 'react-router';
import { AssociatedLendersProvider } from '../../ui-toolkit/associatedLenders/AssociatedLendersProvider';

export const ClientOrdersActivePage: React.FC = () => {
  const history = useHistory();
  /**
   * Since this isn't set up to be a "Switch"able set of routes, this route needs to be stronger to that /client/order/create doesn't fall in by mistake.
   * The regex is for a valid guid for a lender or client id.
   *  */
  return (
    <Layout
      header={<PageHeader active={'orders'} onHomeClick={() => history.push(clientUrls.urlFor.clientOrders())} />}
      footer={<Footer />}
    >
      <SpaceWrapper>
        <AssociatedLendersProvider>
          <OrdersActiveContainer />
        </AssociatedLendersProvider>
      </SpaceWrapper>
    </Layout>
  );
};
